// Copyright (c) 2017 Deere & Company

import actions from '../../actions-list';
import {generateSelectionMap} from '../../../shared/components/facets/dealer-hierarchy/helpers';

const getListOfSelectedDealers = selectedAccounts => Object.keys(selectedAccounts).filter(isSelected => selectedAccounts[isSelected]);

export const updateWipFacets = facets => ({
    facets,
    type: actions.UPDATE_TCSM_WIP_FACETS
});

export const resetWipFacets = territories =>

    dispatch => {

        const initializedDealerHierarchy = generateSelectionMap(territories);

        const selectedDealers = getListOfSelectedDealers(initializedDealerHierarchy.selectedAccounts);

        const facets = {
            dealers: selectedDealers,
            ...initializedDealerHierarchy
        };

        dispatch({
            facets,
            type: actions.UPDATE_TCSM_WIP_FACETS
        });

    };



// WEBPACK FOOTER //
// ./src/tcsm/wip/action-creators/wip-facets.js